import cls from './Game.module.scss';
import { Level1 } from './Level1';
import { useSelector } from 'react-redux';
import { RootState } from '../../shared/redux/store';
import { GameOnb } from '../../widgets/GameOnb/GameOnb';
import { GameEnd } from '../../widgets/GameEnd/GameEnd';
import { Level2 } from './Level2';
import { Level3 } from './Level3';

export const Game = () => {
  const { currentLevel, isGame, isWin } = useSelector((state: RootState) => state.game);

  const levels = [<Level1 />, <Level2 />, <Level3 />];

  const getCurrentComponent = () => {
    if (isWin) {
      return <GameEnd />;
    } else if (isGame) {
      return levels[currentLevel - 1];
    } else {
      return <GameOnb />;
    }
  };

  return <div className={`${cls.Game} page-container`}>{getCurrentComponent()}</div>;
};
